import { render, staticRenderFns } from "./list.vue?vue&type=template&id=0e22deac"
import script from "./list.vue?vue&type=script&lang=tsx"
export * from "./list.vue?vue&type=script&lang=tsx"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports